import type { Components, Theme } from "@mui/material/styles";
import { darkColors, lightColors } from "../tokens/colors.ts";
import { elevation } from "../tokens/elevation.ts";

export function getMuiPaper(mode: "dark" | "light"): Components<Theme>["MuiPaper"] {
  const c = mode === "dark" ? darkColors : lightColors;
  return {
    styleOverrides: {
      root: {
        backgroundImage: "none",
        backgroundColor: mode === "dark" ? c.surfaceContainer : c.surfaceContainerLowest,
      },
      elevation0: {
        boxShadow: "none",
      },
      elevation1: {
        boxShadow: elevation.ghostShadow[mode],
      },
      elevation4: {
        backgroundColor: mode === "dark"
          ? `${c.surfaceVariant}99`
          : `${c.surfaceContainerLowest}cc`,
        ...elevation.glass,
        boxShadow: elevation.ambientShadow[mode],
      },
    },
  };
}
